module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Call-e897fe8a0459aeba48d1aa950581af96.svg";